import { AnchorHTMLAttributes, ForwardedRef, ReactNode, forwardRef } from 'react';
import { Link as FluentLink, LinkProps as FluentLinkProps } from '@fluentui/react-components';
import { Link as RouterLink, To } from 'react-router-dom';

export type AppLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'children'> & {
  to: To;
  /** Carried on the navigation, so the destination can tell a click apart from a query-param write. */
  state?: unknown;
  children: ReactNode;
  appearance?: FluentLinkProps['appearance'];
};

// The remaining anchor props pass through, so a wrapping Tooltip can attach its hover and focus handlers.
const AppLink = forwardRef<HTMLAnchorElement, AppLinkProps>(function AppLink(
  { to, state, children, appearance, ...anchorProps }: AppLinkProps,
  ref: ForwardedRef<HTMLAnchorElement>
) {
  return (
    <RouterLink {...anchorProps} to={to} state={state} ref={ref}>
      <FluentLink appearance={appearance} as="span">
        {children}
      </FluentLink>
    </RouterLink>
  );
});

export { AppLink };
